// RoutesList.js
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  AgentProfile,
  AgentReport,
  Agents,
  PartnerProfile,
  PartnerTypes,
  Partners,
  Branches,
  BranchProfile,
  AddBranch,
  AssignToAgent,
  AssignToBranch,
  AssignToPartner,
  Lockers,
  LockerFees,
  SuspiciousCourierReport,
  LockerStorageFees,
  PaymentModeAndFees,
  StorageTimeLimits,
  LockerTimeLimits,
  LockerUserTypes,
  LockerUserAccounts,
  ViewPackageHistory,
  LockerCleanUp,
  BatchUpload,
  WalletTopUp,
  LockerFullReport,
  ReassignPackage,
  BroadcastAgent,
  LockerOccupancy,
  BroadcastUsers,
  PartnerPerformanceReports,
  StayTimeInLocker,
  PODReports,
  StorageRentals,
  PeakDropoffReportPage,
  PeakHoursReportPage,
  NotFoundPage,
  UnrecognizedWaybillReport,
  OperatorAccounts,
  RolesAndTemplates,
  LockerRemovalRate,
  SuspiciousCourierNumbers,
  DecliningUsage,
  ClearingReport,
} from "../pages/dashboard";
import LoginPage from "../pages/auth/login";
import AddPartner from "../pages/dashboard/partner-profile/component/add-profile";
import { ProtectedRoute } from "./ProtectedRoute"; // Import the ProtectedRoute component
import {
  AddUserFees,
  AddPartnerFees,
} from "../pages/dashboard/locker-fees/components/pages";
import EditPartnerFees from "../pages/dashboard/locker-fees/components/pages/edit-partner-fees";
import PackageHistoryPage from "../pages/dashboard/view-package-history/pages/package-history-page";
import UserProfilePage from "../pages/dashboard/locker-user-accounts/pages/user-profile-page";
import LockerRentalReport from "../pages/dashboard/locker-rental-report";
import EditUserFees from "../pages/dashboard/locker-fees/components/pages/edit-user-fees";
import {
  LockerUserTemplate,
  CourierTemplate,
  LockerCleanUpTemplate,
} from "../pages/dashboard/message-template";
import DropOffStatusHistory from "../pages/dashboard/drop-off-status";
import UserAccessPermission from "../pages/dashboard/user-access-permission";
import AccessDeniedPage from "../pages/dashboard/access-denied-page";
import { Landing } from "../pages/settings";
import AddTemplate from "../pages/dashboard/roles-and-templates/pages/add-template";
import EditTemplate from "../pages/dashboard/roles-and-templates/pages/edit-template";
import CoinsTemplate from "../pages/dashboard/settings-coins";
import AddRedemptionCodeCampaign from "../pages/dashboard/redemption-code-campaign/redemption-code-campaign/add";
// import AddBehavioralCampaign from "../pages/dashboard/settings-coins/behavioral-campaign/add";
import OverstayFeesReport from "../pages/dashboard/overstay-fees-report";
import RedemptionCodeCampaign from "../pages/dashboard/redemption-code-campaign";
import BehavioralCampaign from "../pages/dashboard/behavioral-campaign";
import AddBehavioralCampaign from "../pages/dashboard/behavioral-campaign/behavioral-campaign/add";
import EditBehavioralCampaign from "../pages/dashboard/behavioral-campaign/behavioral-campaign/edit";
import HighRemovalCourier from "../pages/dashboard/high-removal-courier";
import PODSummaryReport from "../pages/dashboard/POD-Summary-Report";
import OverstayFeesReportSummary from "../pages/dashboard/overstay-report-summary";
import StorageRentalFeesSummary from "../pages/dashboard/storage-rental-summary-report";
import LockerUserType from "../pages/dashboard/locker-user-type";
import AccountingRefundRequest from "../pages/accounting";
import CollectionSummaryPage from "../pages/accounting/collection-summary";
import PackageStatusPage from "../pages/accounting/package-status";
import AddNewBranch from "../pages/dashboard/branches/add";
import EditSelectedBranch from "../pages/dashboard/branches/edit";
import WalletHistoryReport from "../pages/reports/wallet-history";
export default function RoutesList() {
  return (
    <Router basename={process.env.REACT_APP_BASE_ENVIRONMENT}>
      <div className="font-montserrat">
        <Routes>
          {/* Public Route */}
          <Route path={"/"} element={<LoginPage />} />
          {/* Protected Routes */}
          <Route
            path={`locker-user-types`}
            element={<ProtectedRoute element={<LockerUserTypes />} />}
          />
          <Route
            path={`partnerTypes`}
            element={<ProtectedRoute element={<PartnerTypes />} />}
          />
          <Route
            path={"agents"}
            element={<ProtectedRoute element={<Agents />} />}
          />
          <Route
            path={`agents/agentProfile/:partnerAgentId`}
            element={<ProtectedRoute element={<AgentProfile />} />}
          />
          <Route
            path={`agentReport`}
            element={<ProtectedRoute element={<AgentReport />} />}
          />
          <Route
            path={`batch-upload`}
            element={<ProtectedRoute element={<BatchUpload />} />}
          />
          <Route
            path={`partners`}
            element={<ProtectedRoute element={<Partners />} />}
          />
          <Route
            path={`partners/partner-profile/:operatorId/:partnerId`}
            element={<ProtectedRoute element={<PartnerProfile />} />}
          />
          <Route
            path={`partners/add-profile/:operatorId/:partnerId`}
            element={<ProtectedRoute element={<AddPartner />} />}
          />

          {/* <Route
            path={`partners/add-partner-admin/:operatorId/:partnerId`}
            element={<ProtectedRoute element={<PartnerAdminAccount />} />}
          /> */}

          <Route
            path={`branches`}
            element={<ProtectedRoute element={<Branches />} />}
          />
          <Route
            path={`branches/branch-profile/:partnerBranchId`}
            element={<ProtectedRoute element={<BranchProfile />} />}
          />

          <Route
            path={`branches/edit-branch/:partnerBranchId`}
            element={<ProtectedRoute element={<EditSelectedBranch />} />}
          />

          <Route
            path={`branches/branch-add`}
            element={<ProtectedRoute element={<AddBranch />} />}
          />
          <Route
            path={`branches/add-branch`}
            element={<ProtectedRoute element={<AddNewBranch />} />}
          />
          <Route
            path={`lockers`}
            element={<ProtectedRoute element={<Lockers />} />}
          />
          <Route
            path={`locker-fees`}
            element={<ProtectedRoute element={<LockerFees />} />}
          />
          <Route
            path={`locker-fees/add-user-fees/:lockerTypeId`}
            element={<ProtectedRoute element={<AddUserFees />} />}
          />
          <Route
            path={`locker-fees/add-partner-fees/:lockerTypeId`}
            element={<ProtectedRoute element={<AddPartnerFees />} />}
          />
          <Route
            path={`locker-fees/edit-partner-fees/:lockerTypeId/:partnerTypeId`}
            element={<ProtectedRoute element={<EditPartnerFees />} />}
          />
          <Route
            path={`assign-to-branch`}
            element={<ProtectedRoute element={<AssignToBranch />} />}
          />
          <Route
            path={`assign-to-agent`}
            element={<ProtectedRoute element={<AssignToAgent />} />}
          />
          <Route
            path={`assign-to-partner`}
            element={<ProtectedRoute element={<AssignToPartner />} />}
          />
          <Route
            path={`suspicious-courier-report`}
            element={<ProtectedRoute element={<SuspiciousCourierReport />} />}
          />
          <Route
            path={`locker-storage-fees`}
            element={<ProtectedRoute element={<LockerStorageFees />} />}
          />
          <Route
            path={`payment-mode-and-fees`}
            element={<ProtectedRoute element={<PaymentModeAndFees />} />}
          />
          <Route
            path={`broadcast-users`}
            element={<ProtectedRoute element={<BroadcastUsers />} />}
          />
          <Route
            path={`storage-time-limits`}
            element={<ProtectedRoute element={<StorageTimeLimits />} />}
          />
          <Route
            path={`locker-time-limits`}
            element={<ProtectedRoute element={<LockerTimeLimits />} />}
          />
          <Route
            path={`locker-user-accounts`}
            element={<ProtectedRoute element={<LockerUserAccounts />} />}
          />
          <Route
            path={`locker-user-accounts/user-profile-page/:userId`}
            element={<ProtectedRoute element={<UserProfilePage />} />}
          />
          <Route
            path={`view-package-history`}
            element={<ProtectedRoute element={<ViewPackageHistory />} />}
          />
          <Route
            path={`view-package-history/:packageId/:userAccountId`}
            element={<ProtectedRoute element={<PackageHistoryPage />} />}
          />
          <Route
            path={`locker-clean-up`}
            element={<ProtectedRoute element={<LockerCleanUp />} />}
          />
          <Route
            path={`partner-performance-report`}
            element={<ProtectedRoute element={<PartnerPerformanceReports />} />}
          />
          <Route
            path={`POD-report`}
            element={<ProtectedRoute element={<PODReports />} />}
          />
          <Route
            path={`staytime-in-locker`}
            element={<ProtectedRoute element={<StayTimeInLocker />} />}
          />
          <Route
            path={`wallet-top-up`}
            element={<ProtectedRoute element={<WalletTopUp />} />}
          />
          <Route
            path={`drop-off-status`}
            element={<ProtectedRoute element={<DropOffStatusHistory />} />}
          />
          <Route
            path={`locker-fees/edit-user-fees/:lockerTypeId/:userTypeId`}
            element={<ProtectedRoute element={<EditUserFees />} />}
          />
          <Route
            path={`locker-full-report`}
            element={<ProtectedRoute element={<LockerFullReport />} />}
          />
          <Route
            path={`locker-user-template`}
            element={<ProtectedRoute element={<LockerUserTemplate />} />}
          />
          <Route
            path={`courier-template`}
            element={<ProtectedRoute element={<CourierTemplate />} />}
          />
          <Route
            path={`locker-cleanup-template`}
            element={<ProtectedRoute element={<LockerCleanUpTemplate />} />}
          />
          <Route
            path={`reassign-packages`}
            element={<ProtectedRoute element={<ReassignPackage />} />}
          />

          <Route
            path={`locker-user-type`}
            element={<ProtectedRoute element={<LockerUserType />} />}
          />
          <Route
            path={`broadcast-agents`}
            element={<ProtectedRoute element={<BroadcastAgent />} />}
          />
          <Route
            path={`locker-occupancy-report`}
            element={<ProtectedRoute element={<LockerOccupancy />} />}
          />
          <Route
            path={`locker-rental-fees`}
            element={<ProtectedRoute element={<LockerRentalReport />} />}
          />
          <Route
            path={`storage-rental-fees`}
            element={<ProtectedRoute element={<StorageRentals />} />}
          />
          <Route
            path={`peak-dropoff-report`}
            element={<ProtectedRoute element={<PeakDropoffReportPage />} />}
          />
          <Route
            path={`peak-hours-report`}
            element={<ProtectedRoute element={<PeakHoursReportPage />} />}
          />
          <Route
            path={`operator-accounts/user-access-permission/:operatorAccountId`}
            element={<ProtectedRoute element={<UserAccessPermission />} />}
          />
          <Route
            path={`operator-accounts`}
            element={<ProtectedRoute element={<OperatorAccounts />} />}
          />
          <Route
            path={`not-found-page`}
            element={<ProtectedRoute element={<NotFoundPage />} />}
          />
          <Route
            path={`access-denied-page`}
            element={<ProtectedRoute element={<AccessDeniedPage />} />}
          />
          <Route
            path={`settings/landing`}
            element={<ProtectedRoute element={<Landing />} />}
          />
          <Route
            path={`unrecognized-waybill`}
            element={<ProtectedRoute element={<UnrecognizedWaybillReport />} />}
          />
          <Route
            path={`roles-and-templates`}
            element={<ProtectedRoute element={<RolesAndTemplates />} />}
          />
          <Route
            path={`roles-and-templates/add-template`}
            element={<ProtectedRoute element={<AddTemplate />} />}
          />
          <Route
            path={`roles-and-templates/edit-template/:operatorAccountRoleId`}
            element={<ProtectedRoute element={<EditTemplate />} />}
          />
          <Route
            path={`locker-removal-rate`}
            element={<ProtectedRoute element={<LockerRemovalRate />} />}
          />

          {/* <Route
						path={`mbox-coin-campaigns`}
						element={<ProtectedRoute element={<CoinsTemplate />} />}
					/> */}

          <Route
            path={`mbox-behavioral-campaigns/add`}
            element={<ProtectedRoute element={<AddBehavioralCampaign />} />}
          />

          <Route
            path={`mbox-behavioral-campaigns/edit-behavioral/:campaignBehaviorId`}
            element={<ProtectedRoute element={<EditBehavioralCampaign />} />}
          />

          <Route
            path={`suspicious-courier-numbers`}
            element={<ProtectedRoute element={<SuspiciousCourierNumbers />} />}
          />
          <Route
            path={`declining-usage-report`}
            element={<ProtectedRoute element={<DecliningUsage />} />}
          />

          {/* summary reports */}
          <Route
            path={`POD-report-summary`}
            element={<ProtectedRoute element={<PODSummaryReport />} />}
          />

          <Route
            path={`storage-fees-report-summary`}
            element={<ProtectedRoute element={<StorageRentalFeesSummary />} />}
          />

          <Route
            path={`overstay-report-summary`}
            element={<ProtectedRoute element={<OverstayFeesReportSummary />} />}
          />

          {/* coin campaigns */}
          <Route
            path={`mbox-redemption-code-campaigns`}
            element={<ProtectedRoute element={<RedemptionCodeCampaign />} />}
          />
          <Route
            path={`mbox-redemption-code-campaigns/add`}
            element={<ProtectedRoute element={<AddRedemptionCodeCampaign />} />}
          />
          <Route
            path={`mbox-behavioral-campaigns`}
            element={<ProtectedRoute element={<BehavioralCampaign />} />}
          />
          {/* end */}

          <Route
            path={`locker-clearing-summary`}
            element={<ProtectedRoute element={<ClearingReport />} />}
          />

          <Route
            path={`overstay-fees-report`}
            element={<ProtectedRoute element={<OverstayFeesReport />} />}
          />

          <Route
            path={`high-removal-courier`}
            element={<ProtectedRoute element={<HighRemovalCourier />} />}
          />

          <Route
            path={`wallet-history-report`}
            element={<ProtectedRoute element={<WalletHistoryReport />} />}
          />

          {/* <Route
            path={`double-payment-report`}
            element={<ProtectedRoute element={<DoublePaymentReport />} />}
          /> */}
          <Route
            path={`collection-summary`}
            element={<ProtectedRoute element={<CollectionSummaryPage />} />}
          />

          <Route
            path={`package-status`}
            element={<ProtectedRoute element={<PackageStatusPage />} />}
          />

          <Route
            path={`refund-request`}
            element={<ProtectedRoute element={<AccountingRefundRequest />} />}
          />

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </Router>
  );
}
